import React from 'react';
import { motion } from 'framer-motion';
import { Shield, BookOpen, Globe, Award } from 'lucide-react';
export function TrustSection() {
  const badges = [{
    icon: <BookOpen className="w-6 h-6 text-brand-gold" data-id="element-280" />,
    label: '100% Educativo'
  }, {
    icon: <Globe className="w-6 h-6 text-brand-gold" data-id="element-281" />,
    label: 'Enfocado en USA'
  }, {
    icon: <Award className="w-6 h-6 text-brand-gold" data-id="element-282" />,
    label: 'Contenido Premium'
  }];
  return <section className="py-20 bg-brand-green" data-id="element-283">
      <div className="container mx-auto px-6 max-w-4xl text-center" data-id="element-284">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="flex flex-col items-center" data-id="element-285">
          <Shield className="w-14 h-14 text-brand-gold mb-6" data-id="element-286" />
          <p className="text-xl md:text-2xl font-serif text-brand-gold leading-relaxed italic mb-8" data-id="element-287">
            "Diseñado para personas en Estados Unidos que quieren entender el
            sistema de crédito de forma clara, práctica y estratégica."
          </p>
          <div className="flex flex-wrap justify-center gap-6" data-id="element-288">
            {badges.map((badge, i) => <motion.div key={i} className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-5 py-3 rounded-full border border-brand-gold/30" initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: i * 0.1
          }} data-id="element-289">
                {badge.icon}
                <span className="text-sm font-semibold text-brand-gold" data-id="element-290">
                  {badge.label}
                </span>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}